<template>
  <v-navigation-drawer
    v-model="getThemeMode.verticalSidebarDrawer"
    class="sideMenu"
    height="100%"
    width="274px"
    :mobile-breakpoint="960"
    :floating="true"
    app
  >
    <vue-perfect-scrollbar
      :settings="{ suppressScrollX: true, wheelPropagation: false }"
      class="ps"
      style="height: 100%"
    >
      <div class="mt-4 top-toolbar text-center">
        <img class="px-3 company-logo" :src="logo">
      </div>
      <v-divider class="my-5 sideItemDivider"></v-divider>

      <v-list class="py-0 mx-4" dense>
        <template v-for="(item, i) in computedItems">
          <div :key="item.subheader" v-if="item.subheader">
            <!-- <v-subheader>
              {{ item.subheader }}
            </v-subheader> -->

            <v-divider class="sideItemDivider"></v-divider>
          </div>

          <base-item-group-two
            v-if="item.children"
            :key="`group-${i}`"
            :item="item"
          >
            <!--  -->
          </base-item-group-two>

          <base-item-two
            v-else-if="!item.subheader"
            :key="`item-${i}`"
            :item="item"
          />
        </template>
      </v-list>
      <v-divider class="my-5 sideItemDivider"></v-divider>
      <a href="https://dashboard.boundlessdigital.com/" target="_blank" class="logo-wrapper" v-if="showBoundless">
        <img src="@/assets/images/logos/boundless-logo.png">
      </a>
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    isDemo: {
      type: Boolean,
      default: false,
    },
    themeName: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      selectedItem: 0,
      group: null,
      showMenu: false
    }
  },
  computed: {
    ...mapGetters(['getThemeMode']),
    bg() {
      return this.background
        ? 'https://images.pexels.com/photos/1687678/pexels-photo-1687678.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260'
        : undefined
    },
    getMiniVariant() {
      return this.miniVariant
    },
    computedItems() {
      // return this.items.map(this.mapItem);
      return this.$vuetify.theme.themes?.light?.sideMenuItems || []
      // console.log(this.items);
      // return this.items;
    },
    logo() {
      return this.$vuetify.theme.themes.light.logo
    },
    showBoundless() {
      let showBoundless =  (this.themeName !== 'default') && (this.themeName !== 'demo')
      return showBoundless

    }
  },
  methods: {
    ...mapActions(['changeVerticalSidebarDrawer']),
    toggleSidebar() {
      this.changeVerticalSidebarMini()
      this.expandOnHover = !this.expandOnHover
      // this.$emit("update:mini-variant");
      // console.log("check");
    },
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: item.title
        // to: !item.to ? undefined : `/app/${this.item.group}/${item.to}`,
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.v-navigation-drawer {
  background-color: $black;

  .v-list-item--link:before {
    border-radius: 8px;
  }

  .top-toolbar {
    .company-logo {
      max-width: 90%;
      height: auto;
    }
  }

  .logo-wrapper {
    position: absolute;
    bottom: 0;
    text-align: center;

    img {
      width: 70%;
    }
  }
}
</style>
